"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastOpenedSystemsContainerMetaElement = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LastOpenedSystemsContainerMetaElement = styled_components_1.default.div `
  p {
    font-size: 12px;
    margin: 5px 0;
  }
`;
//# sourceMappingURL=last-opened-systems-container-meta-element.js.map